'use strict';

var Consts = require('consts');
var Misc = require('utils/misc');
var I18N = require('utils/i18n');

function getIcon(catName) {
    switch (catName) {
        case 'CHILD-COUNT':
            return 'fa fa-hashtag';
        case 'USER-COUNT':
            return 'fa fa-user';
        case 'DEVICE-COUNT':
            return 'fa fa-server';
        case 'GATEWAY-COUNT':
            return 'fa fa-server';
        case 'CONNECTED-DEVICE-COUNT':
            return 'fa fa-server';
    }

    catName = catName || '';
    var parts = catName.split('/');
    if (parts.length > 0) catName = parts[0];

    var catObj = Consts.DeviceCategory[catName] || {};
    return catObj.icon;
}

function getName(itemName, catName) {
    switch (catName) {
        case 'GATEWAY-COUNT':
            return I18N.TR('Anzahl der direkt verbundenen Geräte');
        case 'CONNECTED-DEVICE-COUNT':
            return I18N.TR('Anzahl der angeschlossenen Geräte');
    }

    return I18N.TR(itemName);
}

// "register" some translation strings

// I18N.TR('TROVIS (Heizungs-) Regler)
// I18N.TR('Anzahl der API-Abfragen)
// I18N.TR('Anzahl der angeschlossenen Geräte/GW)
// I18N.TR('Geräte Anzahl)
// I18N.TR('Features)
// I18N.TR('Unbekanntes Gateway)
// I18N.TR('SAM LAN GATEWAY (Funktechnologie))
// I18N.TR('SAM MOBILE GATEWAY (Mobilfunk))
// I18N.TR('SAM HOME GATEWAY (LAN, DSL))
// I18N.TR('5578-E RegCom TCP Platine)
// I18N.TR('SAM VM GATEWAY (Software))
// I18N.TR('Verbrauchszähler)
// I18N.TR('SMS Nachricht bei (Anlagen-) Störung)
// I18N.TR('Anzahl der Benutzer)

var BillingView = Marionette.ItemView.extend({
    template: require('components/profile/templates/billing'),

    initialize: function (options) {
        this.model = options.model;
        this.stats = undefined;

        var billing = this.model.get('billing');
        var items = this.model.get('items');

        if (billing && billing.length > 0) {
            this.stats = this.prepareDeviceStats(billing[0].device_stats, items);
        }
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        data.stats = this.stats;
        data.isInvoice = true;

        return data;
    },

    onShow: function () {
        Misc.equalizeHeight($('.card-box'));
    },

    prepareDeviceStats: function (stats, items) {
        stats = _.map(_.pairs(stats), function (statItem) {
            return {
                name: getName(items[statItem[0]], statItem[0]),
                count: statItem[1],
                icon: getIcon(statItem[0]),
            };
        });
        stats = _.sortBy(
            _.filter(stats, function (e) {
                return e.count > 0 && e.name !== undefined;
            }),
            function (x) {
                return x.name;
            }
        );

        return stats.length != 0 ? stats : undefined;
    },
});

module.exports = BillingView;
